import { Download, Printer, PenLine } from "lucide-react";
import { trackDownload } from "@/lib/api";

/** Three ways to use a pack: a ready-made PDF to print and complete by hand, print/save with on-screen answers, or fill in online. */
export const DownloadChoices = ({ file, resource, href, onPrint, onFillOnline, testid, label = "PDF", className = "", note = true }) => (
  <div className={className} data-testid={`${testid}-choices`}>
    <div className="flex flex-wrap gap-3">
      <a href={href || `/pdfs/${file}`} download={href ? undefined : file} onClick={() => trackDownload(`${resource}-pdf`)}
        className="btn btn-brand text-base" data-testid={testid}>
        <Download size={18} aria-hidden /> Download {label}
      </a>
      {onPrint && (
        <button type="button" onClick={onPrint} className="btn btn-ghost text-base" data-testid={`${testid}-print`}>
          <Printer size={18} aria-hidden /> Print or save with my answers
        </button>
      )}
      {onFillOnline && (
        <button type="button" onClick={onFillOnline} className="btn btn-ghost text-base" data-testid={`${testid}-online`}>
          <PenLine size={18} aria-hidden /> Fill it in online
        </button>
      )}
    </div>
    {note && (
      <p className="mt-3 max-w-2xl text-sm text-ink-soft">
        {note === true ? "The PDF is blank, ready to print and complete by hand. To keep what you've typed on screen, use \"Print or save with my answers\" and choose \"Save as PDF\"." : note}
      </p>
    )}
  </div>
);
